import { isKey } from '../../utils'
import { UiTheme } from '../../theme'

export default (theme: UiTheme) => {
  const getDismissButtonStyle = (variant: string) => {
    const hoverKey = `${variant}Hover`
    const activeKey = `${variant}Active`
    const borderKey = `${variant}Border`

    return {
      backgroundColor: isKey(theme.colors.accents, variant) ? theme.colors.accents[variant] : undefined,
      ':hover': {
        backgroundColor: isKey(theme.colors.accents, hoverKey) ? theme.colors.accents[hoverKey] : undefined,
      },
      ':active': {
        backgroundColor: isKey(theme.colors.accents, activeKey) ? theme.colors.accents[activeKey] : undefined,
      },
      ':focus': {
        backgroundColor: isKey(theme.colors.accents, hoverKey) ? theme.colors.accents[hoverKey] : undefined,
        boxShadow: isKey(theme.colors.accents, borderKey) ? `0 1px 8px ${theme.colors.accents[borderKey]}` : undefined,
      },
    }
  }

  return {
    wrapper: {
      base: {
        width: '300px',
        transition: `all 500ms ${theme.settings.timingFunctions.easeInOutBack}, background-color 150ms ${theme.settings.timingFunctions.easeInOutQuad}`,
        opacity: 0,
        transform: 'translate(30px)',

        '@media (prefers-reduced-motion: reduce)': {
          transition: 'none',
          transform: 'none',
        },
      },

      visible: {
        opacity: 1,
        transform: 'translate(0)',
      },
    },
    snackbar: {
      base: {
        display: 'flex',
        flexDirection: 'row',
        padding: theme.settings.spacing.large,
        borderRadius: '5px',
        transition: `all 500ms ${theme.settings.timingFunctions.easeInOutBack}, background-color 150ms ${theme.settings.timingFunctions.easeInOutQuad}`,
        boxShadow: theme.settings.shadows.elevation[2],

        '.intent-mouse &:focus': {
          outline: 'none',
        },
      },

      variants: {
        primary: {
          backgroundColor: theme.colors.accents.primary,
          color: 'white',
        },

        positive: {
          backgroundColor: theme.colors.accents.positive,
          color: 'white',
        },

        negative: {
          backgroundColor: theme.colors.accents.negative,
          color: 'white',
        },
      },

      hoverable: {
        cursor: 'pointer',

        variants: {
          primary: {
            ':hover': {
              backgroundColor: theme.colors.accents.primaryHover,
            },
            ':active': {
              backgroundColor: theme.colors.accents.primaryActive,
            },
          },

          positive: {
            ':hover': {
              backgroundColor: theme.colors.accents.positiveHover,
            },
            ':active': {
              backgroundColor: theme.colors.accents.ctaActive,
            },
          },

          negative: {
            ':hover': {
              backgroundColor: theme.colors.accents.negativeHover,
            },
            ':active': {
              backgroundColor: theme.colors.accents.negativeActive,
            },
          },
        },
      },
    },

    content: {
      base: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
      },
    },

    title: {
      base: {
        flex: 1,
        ...theme.typography.body,
        fontWeight: theme.settings.typography.weights.semibold,
        marginTop: 0,
        marginBottom: 0,
      },
    },

    description: {
      base: {
        flex: 1,
        ...theme.typography.body,
        marginBottom: 0,
        marginTop: 0,
      },

      variants: {
        regular: {},
        cta: {
          fontWeight: theme.settings.typography.weights.semibold,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },

    icon: {
      base: {
        flex: '0 40px',
      },
    },

    dismissButton: {
      base: {
        ...theme.typography.body,
        padding: 0,
        position: 'absolute',
        top: theme.settings.spacing.xSmall,
        right: theme.settings.spacing.xSmall,
        width: theme.settings.spacing.xLarge,
        height: theme.settings.spacing.xLarge,
        display: 'block',
        cursor: 'pointer',
        outline: 'none',
        border: 'none',
        borderRadius: theme.settings.borderRadiuses.regular,
      },

      'variant-primary': getDismissButtonStyle('primary'),
      'variant-positive': getDismissButtonStyle('positive'),
      'variant-negative': getDismissButtonStyle('negative'),
    },
  }
}
